<template>
  <div>
    <div class="alert alert-danger" v-if="error" v-html="error"></div>
    <return-list v-if="!currentItem"></return-list>
    <return-request v-else></return-request>
    <loader v-if="loading"></loader>
  </div>
</template>

<script>
  import ReturnList from './ReturnList'
  import { mapGetters } from 'vuex'
  import ReturnRequest from './ReturnRequest'
  import Loader from '../../Loader'

  export default {
    name: 'return-component',
    components: {Loader, ReturnList, ReturnRequest},
    computed: {
      ...mapGetters('return', [
        'orders',
        'currentItem',
        'error',
        'loading'
      ])
    },
    methods: {
      request (item, $event) {
        $event.preventDefault()
        this.$store.commit('return/setCurrentItem', {item})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Personal/Return/ReturnComponent.vue